module.exports = __webpack_public_path__ + "static/macgregors-logo-fc16ff7a287643f2abff0937236d98f0.jpg";